import React from "react";
import { MdSearch, MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import CommonTable from "../../../AdminPanel/Component/UI/CommonTable";

const UpdateUserModal = ({ isOpen, onClose, onReupload }) => {

  if (!isOpen) return null;
  const data = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    name: "Aarav Sharma",
    email: "aarav.sharma@companydemo.in",
    role: i === 9 ? "Admin" : "User",
  }));

  const columns = [
    { key: "id", label: "S.No." },
    { key: "name", label: "Name" },
    { key: "email", label: "Email Address" },
    { key: "role", label: "Role" },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      {/* Modal Container */}
      <div className="bg-white w-full max-w-3xl rounded-2xl shadow-xl overflow-hidden">

        {/* ================= Header ================= */}
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-900">
            Uploaded Users Preview
          </h2>
        </div>

        {/* ================= Table Section ================= */}
        <div className="px-6 py-4">
          <div className="border rounded-lg overflow-hidden">
            <div className="flex justify-between items-center px-4 pt-4 pb-2">
              <div className="flex items-center gap-2 text-sm text-black">
                Show
                <select className="border rounded-md px-2 py-1">
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                entries
              </div>

              <div className="flex items-center gap-3 text-sm text-black">
                <div className="relative">
                  <MdSearch size={22} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input type="text" placeholder="Search" className="w-56 pl-9 pr-3 py-2 border border-[#D9D9D9] text-gray-500 rounded-md text-sm focus:outline-none" />
                </div>

                <div>1–20 of 150</div>
                <div className="p-2 rounded-md bg-gray-200 text-teal-600">
                  <MdArrowBackIos size={20} />
                </div>
                <div className="p-2 rounded-md bg-gray-200 text-teal-600">
                  <MdArrowForwardIos size={20} />
                </div>
              </div>
            </div>
            <div className="max-h-[260px] overflow-auto">
              <div className="overflow-x-auto bg-white p-4">

                <CommonTable
                  columns={columns}
                  data={data}
                  renderActions={() => (
                    <div className="flex gap-2">
                      <div className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-gray-200">
                        <FiEdit size={18} />
                      </div>
                      <div className="p-2 cursor-pointer rounded bg-red-100 text-red-600 hover:bg-red-200">
                        <RiDeleteBinLine size={18} />
                      </div>
                    </div>
                  )}
                />

              </div>
            </div>
          </div>
        </div>

        {/* ================= Error Section ================= */}
        <div className="px-6 py-4">
          <p className="text-red-600 font-medium mb-2">
            Following errors are found
          </p>

          <div className="border border-gray-300 rounded-lg bg-gray-50 max-h-[120px] overflow-auto p-4">
            <ol className="list-decimal pl-5 text-sm text-red-600 space-y-1">
              <li>Doesn't contain valid email heading</li>
              <li>Doesn't contain valid emp_id</li>
              <li>Contains special character at Column 2 i.e. First Name</li>
              <li>Contains special character at Column 3 i.e. Last Name</li>
              <li>Contains special character at Column 4 i.e. Is Manager</li>
              <li>Contains special character at Column 5 i.e. Team Name</li>
            </ol>
          </div>
        </div>

        {/* ================= Footer ================= */}
        <div className="px-6 py-4 border-t flex justify-between items-center">
          <div className="text-sm text-gray-600">
            <p className="font-medium text-gray-800">
              File validation was successful
            </p>
            <p>4 new columns are added!</p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="px-5 py-2 border rounded-md text-gray-700 hover:bg-gray-100"
            >
              Cancel
            </button>

            <button
              onClick={onReupload}
              className="px-5 py-2 rounded-md bg-teal-600 text-white hover:bg-teal-700"
            >
              Reupload
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default UpdateUserModal;
